<div
  class="learning-path-info"
  *ngIf="learningPath && learningPath.learningPath"
>
  <app-page>
    <app-panel>
      <div class="top-cta">
        <dx-button
          [text]="'COMMON.BACK' | translate"
          icon="back"
          type="default"
          class="integration-btn"
          (click)="navigateBack()"
        >
        </dx-button>
      </div>
      <div class="learning-path-heading">
        <div class="learning-path-details">
          <div class="learning-path-name">
            {{ learningPath.learningPath.name }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-lg-5">
          <div class="learning-path-image-container">
            <img
              class="learning-path-image"
              [src]="learningPath.learningPath.imageFile?.fileUrl"
              appTrainingImageFallback
            />
          </div>
        </div>
        <div class="col-md-12 col-lg-7">
          <div class="learning-path-widget">
            <div class="learning-path-description">
              {{ learningPath.learningPath.description! }}
            </div>
            <div
              *ngIf="learningPath.files && learningPath.files.length"
              class="learning-path-widget-item"
            >
              <div class="learning-path-widget-badge">
                <i class="dx-icon-link dx-svg-icon-default"></i>
                {{ "TRAINING-CATALOGUE.AVAILABLE-FILES" | translate }}:
              </div>
              <div class="learning-path-widget-value">
                <div
                  *ngFor="let file of learningPath.files"
                  class="learning-path-item-file"
                >
                  <a [href]="file.fileUrl" target="_blank">
                    {{ file.fileName }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="learning-path-description-widget">
        <div class="learning-path-widget-title">
          {{ "COMMON.FIELDS.DESCRIPTION" | translate }}
        </div>
        <dx-form
          class="course-description-form"
          labelLocation="top"
          [showColonAfterLabel]="false"
          [formData]="learningPath.learningPath"
        >
          <dxi-item
            dataField="descriptionExtended"
            label=""
            editorType="dxHtmlEditor"
            [editorOptions]="{
              label: '',
              maxHeight: 280,
              readOnly: true
            }"
          >
            <dxo-label text=" "></dxo-label>
          </dxi-item>
        </dx-form>
      </div>
    </app-panel>
    <app-panel>
      <div class="events-list-container">
        <div class="events-list-filters">
          <dx-text-box
            class="search-input"
            icon="search"
            width="100%"
            labelMode="floating"
            stylingMode="outlined"
            [label]="'COMMON.SEARCH' | translate"
            [value]="searchString"
            valueChangeEvent="input"
            (onValueChanged)="onSearchInput($event)"
          >
            <dxi-button
              name="search"
              type="danger"
              location="before"
              [options]="{ icon: 'search', type: 'default', disabled: true }"
            ></dxi-button>
          </dx-text-box>
        </div>
        <div class="cards-container">
          <!-- <dx-tree-list
            id="courses"
            *ngIf="eventsList && eventsList.length"
            [dataSource]="eventsList"
            [rootValue]="null"
            keyExpr="id"
            parentIdExpr="parentId"
            [showBorders]="false"
            [showColumnLines]="false"
            [showRowLines]="true"
            [columnAutoWidth]="true"
            [allowColumnResizing]="true"
            [columnResizingMode]="'nextColumn'"
            [scrolling]="{ mode: 'standard' }"
            [autoExpandAll]="true"
          >
            <dxo-selection mode="single"></dxo-selection>
            <dxi-column
              [caption]="'COMMON.FIELDS.NAME' | translate"
              dataField="this"
              cellTemplate="detailsTemplate"
              alignment="left"
            ></dxi-column>
            <div *dxTemplate="let data of 'detailsTemplate'" class="card-wrapper">
              <app-training-card
                [training]="data.value"
                [isLearningPath]="true"
                [learningPathId]="learningPathId"
              />
            </div>
          </dx-tree-list> -->
          <div *ngFor="let event of eventsList" class="card-wrapper">
            <app-training-card
              [trainers]="event.trainers"
              [training]="event"
              [isNew]="event.isNew"
              [isLearningPath]="true"
              [learningPathId]="learningPathId"
              [isLocked]="isTrainingLocked(event)"
            />
          </div>
        </div>
      </div>
    </app-panel>
  </app-page>
</div>
